import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const getNewDetailByRowKeyApi = (rowKey) => {
  return httpService({
    url: contextPath + '/parse/failed/web/item/detailById',
    method: 'get',
    params: {
      parseFailedWebId: rowKey
    }
  })
}